import { Stack, Container, Typography } from '@mui/material';
import DepositTableView from 'src/sections/management/user/tabs/deposit/deposit-view';

export default function DepositView() {
  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom>
          ฝากสินค้า
        </Typography>
        <DepositTableView enableCreate isCreateAndApprove />
      </Stack>
    </Container>
  );
}
